import Select from "react-select";
import DatePicker from "components/Common/DatePicker/datepicker";

const Search_By_Date = [
  { label: "Registration Date", value: "REGISTRATION_DATE" },
  { label: "Sample Receiving Date", value: "SAMPLE_RECEIVED_DATE" },
  { label: "Approved Date", value: "APPROVED_DATE" },
];

const CommonFilter = ({
  searchValue,
  handleInputChange,
  handleSearch,
  handleCheckboxChange,
  options,
  selectedZone,
  setSelectedZone,
  investigation_list,
  package_list,
  franchise_list,
  lab_department_list,
}) => {
  const selectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  return (
    <div className="boxBody">
      <div className="heading-form">Search Options</div>

      <div className="row">
        {/* Registration No. */}
        <div className={`col-md-2 mb-2`}>
          <label className="mb-2">Registration No.</label>
          <input
            name="registration_no"
            type="text"
            className="form-control"
            value={searchValue.registration_no || ""}
            onChange={(e) =>
              handleInputChange("registration_no", e.target.value)
            }
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />
        </div>

        {/* Appointment Id */}
        <div className={`col-md-2 mb-2`}>
          <label className="mb-2">Appointment Id</label>
          <input
            name="appointment_id"
            type="text"
            className="form-control"
            value={searchValue.appointment_id || ""}
            onChange={(e) =>
              handleInputChange("appointment_id", e.target.value)
            }
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />
        </div>

        {/* Patient Name */}
        <div className={`col-md-2 mb-2`}>
          <label
            className="mb-2"
            style={{ color: "rgb(13, 110, 253)", fontWeight: "600" }}
          >
            Patient Name
          </label>
          <input
            name="patient_name"
            type="text"
            className="form-control"
            value={searchValue.patient_name}
            onChange={(e) => handleInputChange("patient_name", e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />
        </div>

        {/* Search By Date */}
        <div className={`col-md-2 mb-2`}>
          <label className="mb-2">Search By Date</label>
          <Select
            options={Search_By_Date}
            name="search_by_date"
            isClearable
            placeholder="Search By Date"
            menuPortalTarget={document.body}
            styles={selectStyles}
            value={
              Search_By_Date.find(
                (item) => item.value === searchValue.search_by_date,
              ) || null
            }
            onChange={(val) =>
              handleInputChange("search_by_date", val?.value || "")
            }
          />
        </div>

        {/* Barcode Number */}
        <div className={`col-md-2 mb-2`}>
          <label className="mb-2">Barcode Number</label>
          <input
            name="barcode_no"
            type="text"
            className="form-control"
            value={searchValue.barcode_no || ""}
            onChange={(e) => handleInputChange("barcode_no", e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />
        </div>

        {/* Mobile Number */}
        <div className={`col-md-2 mb-2`}>
          <label className="mb-2">Mobile Number</label>
          <input
            name="mobile_no"
            type="number"
            className="form-control"
            value={searchValue.mobile_no || ""}
            onChange={(e) => handleInputChange("mobile_no", e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />
        </div>

        {/* Card Number */}
        <div className={`col-md-2 mb-2`}>
          <label className="mb-2">Card Number</label>
          <input
            name="card_no"
            type="number"
            className="form-control"
            value={searchValue.card_no || ""}
            onChange={(e) => handleInputChange("card_no", e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />
        </div>

        {/* From Date */}
        <div className="col-md-2 mb-2">
          <label className="mb-2">From Date</label>
          <DatePicker
            name="from_date"
            value={searchValue.from_date}
            onChange={(date) => handleInputChange("from_date", date)}
          />
        </div>

        {/* To Date */}
        <div className="col-md-2 mb-2">
          <label className="mb-2">To Date</label>
          <DatePicker
            name="to_date"
            value={searchValue.to_date}
            onChange={(date) => handleInputChange("to_date", date)}
          />
        </div>

        {/* UHID Number */}
        <div className={`col-md-2 mb-2`}>
          <label className="mb-2">UHID Number</label>
          <input
            name="uhid"
            type="number"
            className="form-control"
            value={searchValue.uhid_no || ""}
            onChange={(e) => handleInputChange("uhid_no", e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />
        </div>

        {/* Slide Number */}
        <div className={`col-md-2 mb-2`}>
          <label className="mb-2">Slide Number</label>
          <input
            name="slide"
            type="number"
            className="form-control"
            value={searchValue.slide_no || ""}
            onChange={(e) => handleInputChange("slide_no", e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />
        </div>

        {/* Gender */}
        <div className={`col-md-2 mb-2`}>
          <label className="mb-2">Gender</label>
          <select
            className="form-control"
            value={searchValue.gender || ""}
            onChange={(e) => handleInputChange("gender", e.target.value)}
          >
            {[
              { key: "Both", value: "", label: "Both" },
              { key: "Male", value: "male", label: "Male" },
              { key: "Female", value: "female", label: "Female" },
              {
                key: "Transgender",
                value: "transgender",
                label: "Transgender",
              },
            ].map((option) => (
              <option key={option.key} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        {/* Center */}
        <div className={`col-md-2 mb-2`}>
          <label className="mb-2">Center</label>
          <Select
            options={options}
            value={selectedZone}
            name="zone_id"
            isClearable
            placeholder="Select Center"
            menuPortalTarget={document.body}
            styles={selectStyles}
            onChange={(val) => {
              setSelectedZone(val);
              handleInputChange("zone_id", val?.value || "");
            }}
          />
        </div>

        {/* Department */}
        <div className={`col-md-2 mb-2`}>
          <label className="mb-2">Department</label>
          <Select
            options={lab_department_list?.data?.map((item) => ({
              value: item.id,
              label: item.department,
            }))}
            value={(() => {
              const item = lab_department_list?.data?.find(
                (i) => i.id == searchValue.lab_department_id,
              );
              return item
                ? { value: item.id, label: item.department || "" }
                : null;
            })()}
            name="lab_department_id"
            isClearable
            placeholder="Select Department"
            menuPortalTarget={document.body}
            styles={selectStyles}
            onChange={(val) =>
              handleInputChange("lab_department_id", val?.value || "")
            }
          />
        </div>

        {/* Refered By */}
        <div className="col-md-2 mb-2">
          <label className="mb-2">Refered By</label>
          <input
            type="text"
            name="refered"
            placeholder="Enter Refered By"
            value={searchValue.refered_by || ""}
            onChange={(e) => handleInputChange("refered_by", e.target.value)}
            className="form-control"
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />
        </div>

        {/* Panel */}
        <div className={`col-md-2 mb-2`}>
          <label className="mb-2">Panel</label>
          <Select
            key={
              franchise_list?.data ? `franchise-loaded` : `franchise-loading`
            }
            options={franchise_list?.data?.map((item) => ({
              value: item.id,
              label: `${item.company_name}, ${item.franchise_code}`,
            }))}
            value={(() => {
              const item = franchise_list?.data?.find(
                (i) => String(i.id) === String(searchValue.franchise_id),
              );
              return item
                ? {
                    value: item.id,
                    label: `${item.company_name}, ${item.franchise_code}`,
                  }
                : null;
            })()}
            name="panel"
            isClearable
            placeholder="Select Panel"
            menuPortalTarget={document.body}
            styles={selectStyles}
            onChange={(val) =>
              handleInputChange("franchise_id", val?.value || "")
            }
          />
        </div>

        {/* Investigation */}
        <div className={`col-md-2 mb-2`}>
          <label className="mb-2">Investigation</label>
          <Select
            options={investigation_list?.data?.map((item) => ({
              value: item.id,
              label: item.investigation_name,
              investigation_id: item.id,
            }))}
            name="investigation"
            isClearable
            value={(() => {
              const item = investigation_list?.data?.find(
                (i) => i.id == searchValue.investigation_id,
              );
              return item
                ? { value: item.id, label: item.investigation_name || "" }
                : null;
            })()}
            placeholder="Select Investigation"
            menuPortalTarget={document.body}
            styles={selectStyles}
            onChange={(val) =>
              handleInputChange("investigation_id", val?.value || "")
            }
          />
        </div>

        {/* Package */}
        <div className={`col-md-2 mb-2`}>
          <label className="mb-2">Package</label>
          <Select
            options={package_list?.data?.map((item) => ({
              value: item.id,
              label: item.package_name,
              package_cost: item.package_cost,
            }))}
            name="package"
            isClearable
            value={(() => {
              const item = package_list?.data?.find(
                (i) => i.id == searchValue.package_id,
              );
              return item
                ? { value: item.id, label: item.package_name || "" }
                : null;
            })()}
            placeholder="Select Package"
            menuPortalTarget={document.body}
            styles={selectStyles}
            onChange={(val) =>
              handleInputChange("package_id", val?.value || "")
            }
          />
        </div>

        {/* Outsource To Lab */}
        <div className={`col-md-2 mb-2`}>
          <div className="form-check mt-2">
            <input
              className="form-check-input"
              type="checkbox"
              value=""
              id="outsourceToLab"
            />
            <label className="form-check-label" htmlFor="outsourceToLab">
              Outsource To Lab
            </label>
          </div>
        </div>

        {/* Search Urgent Investigation */}
        <div className={`col-md-3 mb-3`}>
          <div className="form-check mt-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="searchUrgentInvestigation"
              checked={searchValue.is_urgent}
              onChange={handleCheckboxChange}
            />
            <label
              className="form-check-label"
              htmlFor="searchUrgentInvestigation"
            >
              Search Urgent Investigation
            </label>
          </div>
        </div>

        {/* Search Button */}
        <div className={`col-md-2 mb-3`}>
          <button className="btn btn-primary" onClick={handleSearch}>
            Search
          </button>
        </div>
      </div>
    </div>
  );
};

export default CommonFilter;
